import { DealerTierType, FinanceProgram, UpdateFinanceProgramInput } from '@trnsact/trnsact-shared-types';

import { FinanceProgramForm } from '../schema';
import { mapConfigurationFormValuesToCreateOrUpdate } from './mapConfigurationFormValuesToCreateOrUpdate';

export function mapFormValuesToUpdateFinanceProgramInput(
  programToUpdate: FinanceProgram,
  formValue: FinanceProgramForm,
  criteriaId?: string
): Omit<UpdateFinanceProgramInput, 'active'> & { dealerTier?: string | null } {
  const {
    program: { id, first, second },
  } = formValue;

  if (!id) throw new Error('id is required');

  const programAvailableForLenders = [...first.details.lenders, ...first.details.dealers].map(({ value }) => value);

  const currentlyAssociatedLenderProfileIds = (programToUpdate.financeProgramToLenderProfiles ?? [])
    .map(fptlp => fptlp?.lenderProfileId)
    .filter((lpId): lpId is string => !!lpId);

  const selectedLenderProfileIdsSet = new Set(programAvailableForLenders);
  const currentlyAssociatedSet = new Set(currentlyAssociatedLenderProfileIds);

  const lenderProfileIdsToAssociate = programAvailableForLenders.filter(lpId => !currentlyAssociatedSet.has(lpId));
  const lenderProfileIdsToDisassociate = currentlyAssociatedLenderProfileIds.filter(
    lpId => !selectedLenderProfileIdsSet.has(lpId)
  );

  return {
    financeProgramId: id,
    lenderProfileIdsToAssociate,
    lenderProfileIdsToDisassociate,
    nameInternal: first.details.name,
    prescreenCriteriaIdToLink: criteriaId,
    insuranceCoverage: first.insuranceCoverage,
    scoreTiers: second.isTiersEnabled ? { tiers: second.tiers } : null,
    paymentOptionsConfiguration: mapConfigurationFormValuesToCreateOrUpdate(formValue),
    dealerTier: (first.details.dealerTier as DealerTierType | null | undefined) ?? null,
    validDateEnd: second.isValidityDates ? second.endDate : programToUpdate.validDateEnd,
    validDateStart: second.isValidityDates ? second.startDate : programToUpdate.validDateStart,
    submissionSettings: {
      excludedDocuments: first.submissionSettings.excludedDocuments,
      autoSubmitUserProfileId: first.submissionSettings.autoSubmitUserProfileId,
    },
  };
}
